/**
 * Settlement Reports — pre-generated daily XLSX files per merchant, one per
 * SETTLEMENT date: the deposits whose revenue moved Pending → Active that day,
 * i.e. the settlement rows the Wallet page lists under Balance Mutation. Same
 * pipeline and UI as Transaction Reports (`ReportJobsView`); only the period
 * basis differs.
 */
import { ReportJobsView } from '../components/ReportJobsView';

export function SettlementReportsPage() {
  return <ReportJobsView kind="settlement" />;
}
